// i18n area 'vms' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.el-GR.meta.json.
import type { enUS } from './vms'

export const elGR: typeof enUS = {
  vms: {
    spof: {
      title: 'Ανεξαρτησία από τον κόμβο',
      single: 'Μοναδικό σημείο αστοχίας',
      alternativesNow: 'Εναλλακτικές τώρα',
      structural: 'Εκ κατασκευής',
      binding: 'Δεσμευτικός περιορισμός',
      movableNow: 'Δυνατότητα μετεγκατάστασης τώρα',
    },
    title: 'Εικονικές μηχανές',
    migratingChip: 'Μετεγκατάσταση σε εξέλιξη',
    templateChip: 'Πρότυπο',
    expendableTooltip: 'Σε υποβαθμισμένη συστοιχία είναι από τις πρώτες που σταματούν και μπορεί να μην επανεκκινηθεί μετά την απώλεια ενός κόμβου.',
    expendableHaTooltip: 'Επανεκκινείται πάντα όσο η συστοιχία είναι υγιής· σε υποβαθμισμένη συστοιχία οι προστατευμένες VM προηγούνται — μπορεί να σταματήσει ή να μείνει απενεργοποιημένη μέχρι η συστοιχία να ξαναγίνει πλήρης, και μετά επανεκκινείται μόνη της.',
    viewDetails: 'Προβολή λεπτομερειών',
    profileLegacy: 'Άλλο OS',
    hugePagesNone: 'Καμία — κανονική μνήμη',
    hugePages2M: 'Σελίδες 2 MiB',
    hugePages1G: 'Σελίδες 1 GiB',
    searchPlaceholder: 'Αναζήτηση κατά όνομα',
    name: 'Όνομα',

    // Ενιαία ορολογία (#94a): η phase λέγεται «Φάση» παντού — το παλιό
    // κλειδί 'state' πέθανε με το γυάλισμα της λίστας.
    vcpus: 'vCPU',
    memory: 'Μνήμη',
    ipAddresses: 'Διευθύνσεις IP',
    noIp: 'Χωρίς IP',
    authorityNode: 'Αρμόδιος κόμβος',
    authorityNextStart: 'ανατίθεται στην επόμενη εκκίνηση',
    scope: 'Scope',
    empty: 'Καμία εικονική μηχανή',
    loadError: 'Αδυναμία φόρτωσης των εικονικών μηχανών — είναι προσβάσιμο το backend TVirt;',
    filterOverlay: 'δίκτυο επικάλυψης',
    filterDisk: 'δίσκος',
    filterImage: 'εικόνα',
    filteredBy: 'Φιλτραρισμένες κατά {kind}',
    filterPhase: 'Φάση',
    filterProtection: 'Προστασία',
    filterAll: 'Όλες',
    filterScopePlaceholder: 'Φιλτράρισμα κατά scope',
    filtersToggle: 'Φίλτρα',
    scopeTree: {
      title: 'Scope',
      all: 'Ολόκληρη η συστοιχία',
      noChildren: 'Κανένα υπο-scope εδώ',
      recursive: 'Συμπερίληψη απογόνων',
      collapse: 'Σύμπτυξη του πίνακα scope',
      up: 'Ένα επίπεδο πάνω',
      countTooltip: '{direct} VM σε αυτό το scope · {total} μαζί με τους απογόνους'
    },

    // Ο επιλογέας ISO δύο βημάτων (#85): πρώτα ο κατάλογος, μετά οι ISO του.
    isoPicker: {
      catalog: 'Κατάλογος',
      unknownCatalog: 'Εκτός ορατών καταλόγων',
      noIsos: 'Καμία έτοιμη εικόνα ISO σε αυτόν τον κατάλογο'
    },
    actionsHeader: 'Ενέργειες',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Υλικό',
      tags: 'Ετικέτες',
      age: 'Ηλικία',
      disk: 'δίσκος',
      disks: 'δίσκοι',
      empty: 'Κανένα πρότυπο — επισημάνετε ως πρότυπο μια απενεργοποιημένη VM, ή κλωνοποιήστε μια VM ως πρότυπο.',
      clone: 'Κλωνοποίηση / ανάπτυξη',
      editTags: 'Επεξεργασία ετικετών',

      // Γύρος K3 (#64): εξαγωγή του προτύπου ως αρχείο .tvtpl του καταλόγου.
      exportAction: 'Εξαγωγή στον κατάλογο (.tvtpl)',
      exportTitle: 'Εξαγωγή στον κατάλογο',
      exportSubmit: 'Εξαγωγή',
      exportError: 'Η εξαγωγή απέτυχε',
      exportHint: 'Το πρότυπο πακετάρεται σε μια αρχειοθήκη .tvtpl (manifest υλικού + κάθε δίσκος ισοπεδωμένος σε qcow2) ως νέο αρχείο Προτύπου VM στον επιλεγμένο κατάλογο. NIC, μέσα CD/DVD και cloud-init δεν ταξιδεύουν — η προδιαγραφή της μορφής απαριθμεί κάθε σκόπιμη παράλειψη.',
      exportName: 'Όνομα αρχείου',
      exportNameHint: 'Κενό = <template>-export-<n>',
      exportStorageDefault: 'Ο χώρος αποθήκευσης μεταδεδομένων του προτύπου',

      // Εισαγωγή από κατάλογο (Luca 2026-08-03): η είσοδος στη γραμμή εργαλείων
      // της καρτέλας Πρότυπα — το backend K3/K4 καλύπτει όλες τις μορφές
      // vm-template, η επιλογή είναι το ΑΡΧΕΙΟ (η μορφή ταξιδεύει μόνο για ανάγνωση).
      importAction: 'Εισαγωγή από κατάλογο',
      importTitle: 'Εισαγωγή από κατάλογο',
      importHint: 'Ένα αρχείο Προτύπου VM σε κατάσταση ready του επιλεγμένου καταλόγου γίνεται πρότυπο του αποθέματος: η μορφή του αρχείου (tvtpl, ova, ovf ή γυμνό qcow2) αποφασίζει μόνη της πώς εισάγεται — εσείς επιλέγετε μόνο το αρχείο.',
      importFile: 'Αρχείο καταλόγου',
      importFileHint: 'Εισάγονται μόνο αρχεία ready — ένα σε εξέλιξη μεταφόρτωσης δεν είναι εισαγώγιμο',
      importNoFiles: 'Κανένα αρχείο Προτύπου VM σε κατάσταση ready σε αυτόν τον κατάλογο — πρώτα μεταφορτώστε ή εξαγάγετε ένα'
    },
    templateDetail: {
      quickDeploy: 'Συμβατότητα QuickDeploy',
      quickDeployNone: 'Δεν έχει δηλωθεί',
      quickDeployHint: 'Δηλώστε την μόνο αν η golden εικόνα περιέχει cloud-init (Linux) ή cloudbase-init μετά από sysprep /generalize (Windows): η πλατφόρμα εμπιστεύεται τη δήλωση και δεν κοιτά ποτέ μέσα στον guest.',
      notFound: 'Το πρότυπο δεν βρέθηκε',
      frozen: 'Η διαμόρφωση υλικού είναι παγωμένη: μετατρέψτε το πρότυπο ξανά σε VM για να την τροποποιήσετε. Όνομα, σημειώσεις και ετικέτες παραμένουν επεξεργάσιμα.',
      storage: 'Χώρος αποθήκευσης',
      size: 'Μέγεθος',
      configTitle: 'Διαμόρφωση (παγωμένη)',
      usbClasses: 'Απαιτούμενες κλάσεις USB',
      gpuClasses: 'Απαιτούμενες κλάσεις GPU'
    },
    sharedDisksTab: {
      title: 'Κοινόχρηστοι δίσκοι',
      sharing: 'Κοινή χρήση',
      sharingNone: 'Μία μόνο σύνδεση',
      sharingMultiwriter: 'Κοινόχρηστη εγγραφή (multiwriter)',
      sharingReadonly: 'Κοινόχρηστη μόνο ανάγνωση',
      usedBy: 'Σε χρήση από',
      attachedTo: 'Συνδεδεμένος σε',
      notAttached: 'Δεν είναι συνδεδεμένος σε καμία VM',
      changeSharing: 'Αλλαγή τρόπου κοινής χρήσης',
      changeSharingTitle: 'Τρόπος κοινής χρήσης',
      changeSharingLocked: 'Ο τρόπος αλλάζει μόνο όσο καμία VM δεν χρησιμοποιεί τον δίσκο',
      sharingChanged: 'Ο τρόπος κοινής χρήσης ενημερώθηκε.',
      lun: 'Ολόκληρο LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Σειριακός',
      antiAffinityWarning: 'Δύο ή περισσότερα μέλη τρέχουν στον ίδιο κόμβο χωρίς κανόνα αντι-συγγένειας: η βλάβη ενός κόμβου τα ρίχνει όλα',
      antiAffinityCreate: 'Δημιουργία κανόνα',
      createSourceLun: 'Υιοθέτηση ολόκληρου LUN του target',
      createLunNumber: 'Αριθμός LUN (id namespace σε NVMe)',
      createLunHint: 'Τίποτα δεν δεσμεύεται: το μέγεθος διαβάζεται από τη συσκευή κατά την υιοθέτηση',
      noPr: 'Σε αυτή την έκδοση δεν υπάρχουν SCSI-3 persistent reservations: ένα Windows Failover Cluster με κλασικό κοινόχρηστο δίσκο δεν είναι επικυρωμένο· τα cluster που συντονίζονται μέσω δικτύου (GFS2/OCFS2, RHEL HA, βάσεις shared-disk) είναι'
    },
    unusedDisksTab: {
      title: 'Αχρησιμοποίητοι δίσκοι',
      attach: 'Σύνδεση σε VM',
      attachTitle: 'Σύνδεση σε μια VM',
      vm: 'Εικονική μηχανή',
      noVms: 'Καμία διαθέσιμη VM',
      noSlots: 'Κανένα ελεύθερο slot σε αυτή τη VM',

      // Δημιουργία αυτόνομου δίσκου (#87): επέστρεψε από το συνταξιοδοτημένο
      // Απόθεμα, τώρα με ΡΗΤΟ πεδίο scope (δεν υπάρχει VM από την οποία να κληρονομήσει).
      create: 'Δημιουργία δίσκου',
      createTitle: 'Δημιουργία δίσκου',
      createSourceBlank: 'Κενός δίσκος',
      createSourceImage: 'Από εικόνα του καταλόγου',
      createImage: 'Εικόνα',
      createImageEmpty: 'Καμία έτοιμη εικόνα προτύπου VM στους ορατούς καταλόγους',
      createSizeFromImageHint: 'Προσυμπληρωμένο με το εικονικό μέγεθος της εικόνας — μπορεί μόνο να αυξηθεί',

      // #107 (ΚΑΤΑΣΤΡΟΦΙΚΟ, επικυρωμένο): qcow2 → αρχείο καταλόγου vm-template
      // στον ίδιο χώρο αποθήκευσης, μηδέν byte αντιγράφονται — ο δίσκος παύει να υπάρχει.
      convert: 'Μετατροπή σε πρότυπο VM…',
      convertOnlyQcow2: 'Μετατρέπονται μόνο δίσκοι qcow2 — το raw δεν είναι καταχωρίσιμη μορφή προτύπου',
      convertTitle: 'Μετατροπή σε πρότυπο VM',
      convertSubmit: 'Μετατροπή (καταστρέφει τον δίσκο)',
      convertError: 'Αδυναμία εκκίνησης της μετατροπής',
      convertWarning: 'ΚΑΤΑΣΤΡΟΦΙΚΟ: ο δίσκος γίνεται αρχείο προτύπου VM στον επιλεγμένο κατάλογο — ίδιος χώρος αποθήκευσης, μηδέν byte αντιγράφονται — και ΠΑΥΕΙ ΝΑ ΥΠΑΡΧΕΙ ως δίσκος. Δεν υπάρχει επιστροφή, παρά μόνο δημιουργώντας έναν νέο δίσκο από το πρότυπο.',
      convertNameHint: 'Το όνομα του αρχείου καταλόγου — προεπιλογή αυτό του δίσκου',
      convertConfirm: 'Κατάλαβα: ο δίσκος θα καταστραφεί',
      convertStarted: 'Η μετατροπή ξεκίνησε — το πρότυπο εμφανίζεται στον κατάλογο με την ολοκλήρωση της εργασίας.',
      storageLockHint: 'Ο χώρος αποθήκευσης αλλάζει μόνο με την ενέργεια «Μετακίνηση»',
      source: 'Προέλευση',
      sourceClone: 'Κλώνος άλλου δίσκου',
      sourceCloneLinked: 'Συνδεδεμένος κλώνος άλλου δίσκου',
      sourceImage: 'Δημιουργήθηκε από εικόνα',
      sourceBlank: 'Δημιουργήθηκε κενός',
      allocated: 'Δεσμευμένο / εικονικό μέγεθος',
      observedAt: 'Παρατηρήθηκε στις',
      snapshots: 'Στιγμιότυπα',
      snapshotsEmpty: 'Κανένα στιγμιότυπο'
    },
    phase: {
      defined: 'Δεν ενεργοποιήθηκε ποτέ',
      starting: 'Σε εκκίνηση',
      running: 'Εκτελείται',
      stopping: 'Σε τερματισμό',
      stopped: 'Απενεργοποιημένη',
      paused: 'Σε παύση',
      failed: 'Σε σφάλμα',
      deleting: 'Σε διαγραφή'
    },
    stopCause: {
      'api': 'Τερματίστηκε από το TVirt (ενέργεια ή API)',
      'guest-shutdown': 'Τερματισμός που ξεκίνησε το λειτουργικό σύστημα guest',
      'crash': 'Crash του guest',
      'qemu-exit': 'Η διεργασία QEMU τερματίστηκε απροσδόκητα',
      'host-reboot': 'Ο κόμβος επανεκκινήθηκε',
      'migrated': 'Μετεγκαταστάθηκε σε άλλον κόμβο',
      'fenced': 'Τερματίστηκε από το fencing HA (κόμβος που επέστρεψε)'
    },
    detail: {
      notFound: 'Η εικονική μηχανή δεν βρέθηκε',
      details: 'Λεπτομέρειες',
      id: 'ID',
      scope: 'Scope',
      profile: 'Προφίλ υλικού',
      firmware: 'Υλικολογισμικό',
      firmwareFile: 'Έκδοση υλικολογισμικού UEFI',
      firmwareUpdate: 'Διαθέσιμη ενημέρωση',
      firmwareUpdateHint: 'Η πλατφόρμα συνοδεύεται από νεότερο υλικολογισμικό UEFI. Η ενημέρωση δεν είναι ποτέ αυτόματη: εφαρμόζεται με τη VM απενεργοποιημένη, όποτε το αποφασίσετε εσείς.',
      arch: 'Αρχιτεκτονική',
      node: 'Κόμβος',
      bootOrder: 'Σειρά boot',
      agent: 'Κατάσταση agent',
      agentConnected: 'Συνδεδεμένος',
      agentNotConnected: 'Μη συνδεδεμένος',
      protected: 'Προστατευμένη',
      linkedClones: 'Συνδεδεμένοι κλώνοι',
      restartPolicy: 'Πολιτική επανεκκίνησης',
      preferredNode: 'Προτιμώμενος κόμβος',
      noPreference: 'Καμία προτίμηση (αυτόματη τοποθέτηση)',
      preferNodes: 'Προτιμώμενες ετικέτες κόμβου',
      requireNodes: 'Υποχρεωτικές ετικέτες κόμβου',
      noPlacementTags: 'Καμία',
      placementTag: 'Ετικέτα',
      placementValue: 'Τιμή',
      placementAddTag: 'Προσθήκη ετικέτας',
      proximityHa: 'HA του TVirt Proximity',
      proximityHaRestarts: 'επανεκκινήσεις HA',
      proximityHaGaveUp: 'crash loop — το HA παραιτήθηκε',
      failoverProtection: 'Προστασία σε υποβάθμιση',
      protectionProtected: 'Προστατευμένη',
      protectionExpendable: 'Θυσιάσιμη σε υποβάθμιση',
      protectionInherit: 'Κληρονομεί',
      lastStop: 'Τελευταίος τερματισμός',
      yes: 'Ναι',
      no: 'Όχι',
      tabOverview: 'Επισκόπηση',
      tabSnapshots: 'Στιγμιότυπα',
      tabBackups: 'Αντίγραφα',
      hardware: 'Υλικό',
      name: 'Όνομα',
      hwSystem: 'Σύστημα',
      hwCpu: 'CPU',
      hwMemory: 'Μνήμη',
      hwBoot: 'Εκκίνηση',
      hwIdentity: 'Ταυτότητα',
      hwCluster: 'Συστοιχία και agent',
      cpuTopology: 'Τοπολογία CPU',
      cpuModel: 'Μοντέλο CPU',
      cpuLimit: 'Όριο CPU',
      cpuWeight: 'Βάρος CPU',
      cpuNested: "Ένθετη εικονικοποίηση",
      cpuNestedHint: "Εκθέτει vmx/svm στον guest (μόνο με μοντέλο CPU host). Σε VM σε λειτουργία η αλλαγή ισχύει από τον επόμενο power cycle (PendingRestart)· η τοποθέτηση δέχεται μόνο κόμβους με ενεργό nested.",
      unlimited: 'Απεριόριστο',
      memory: 'Μνήμη',
      balloon: 'Balloon',
      hugePages: 'Τεράστιες σελίδες',
      hugePagesTradeoff: 'Λιγότερη δουλειά μετάφρασης διευθύνσεων και μνήμη που δεν καταλήγει ποτέ στον δίσκο· σε αντάλλαγμα η δέσμευση μένει κλειδωμένη στον κόμβο όσο η VM είναι ενεργοποιημένη, η μνήμη δεν αποδιπλοτυποποιείται πλέον και η εκκίνηση αποτυγχάνει αν ο κόμβος δεν έχει αρκετές ελεύθερες σελίδες.',
      disks: 'Δίσκοι',
      cdroms: 'Μονάδες CD/DVD',
      nics: 'Διεπαφές δικτύου',
      slot: 'Slot',
      disk: 'Δίσκος',
      encrypted: 'Κρυπτογραφημένος',
      image: 'Εικόνα',
      emptyDrive: 'Κενή μονάδα',
      emptyOption: '(κενό)',
      network: 'Δίκτυο',
      mac: 'MAC',
      connected: 'Συνδεδεμένη',
      unplugged: 'Αποσυνδεδεμένη',
      noDevices: 'Κανένα',
      screenshot: 'Στιγμιότυπο οθόνης',
      capturedAt: 'Καταγράφηκε στις',
      noCapture: 'Καμία καταγραφή',
      snapshotName: 'Όνομα',
      snapshotCreated: 'Δημιουργήθηκε',
      snapshotMemory: 'Συμπεριλαμβάνεται μνήμη',
      noSnapshots: 'Κανένα στιγμιότυπο',
      pendingRestart: 'Αλλαγές σε εκκρεμότητα: θα εφαρμοστούν στο επόμενο power cycle.',
      applied: 'εφαρμοσμένο',
      appliedHint: 'Η VM εκτελείται με αυτή την τιμή — η διαμορφωμένη εφαρμόζεται στο επόμενο power cycle.',
      actionError: 'Η ενέργεια απέτυχε',
      actionStillRunning: 'Η ενέργεια είναι ακόμη σε εξέλιξη: η έκβαση δεν είναι ακόμη γνωστή',
      tabConsole: 'Κονσόλα',
      consoleConnect: 'Σύνδεση',
      consoleDisconnect: 'Αποσύνδεση',
      consoleConnecting: 'Σύνδεση…',
      consoleReconnecting: 'Σύνδεση…',
      consoleUnavailable: 'Η κονσόλα είναι διαθέσιμη με τη VM σε εκτέλεση ή σε παύση.',
      consoleError: 'Η σύνδεση στην κονσόλα απέτυχε',
      consoleTaken: 'Η συνεδρία κονσόλας καταλήφθηκε από {user}',
      consoleReconnect: 'Επανασύνδεση',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Κρατήστε πατημένο το {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Άνοιγμα σε πλήρη οθόνη σε νέα καρτέλα',
      consoleLoadFailed: 'Η VM δεν βρέθηκε ή τα δικαιώματα δεν επαρκούν',
      consoleClose: 'Κλείσιμο',
      tabStats: 'Στατιστικά',
      tabTasks: 'Εργασίες',
      tabLogs: 'Καταγραφή',
      statsCpu: 'CPU',
      statsMemory: 'Μνήμη',
      statsDisk: 'I/O δίσκου',
      statsRange: 'Εύρος',
      statsNoData: 'Δεν υπάρχουν δεδομένα στο εύρος — τα στατιστικά δειγματοληπτούνται με τη VM σε εκτέλεση.',
      statsError: 'Αδυναμία φόρτωσης των στατιστικών',
      cpuUsage: 'Χρήση',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Σε χρήση',
      memGuestAvailable: 'Διαθέσιμη (guest)',
      schema: 'Schema',
      consoleProtocol: 'Κονσόλα',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Χώρος αποθήκευσης μεταδεδομένων',
      startupOnBoot: 'Εκκίνηση στο boot',
      startupOrder: 'Σειρά εκκίνησης',
      startupDelay: 'Καθυστέρηση εκκίνησης',
      seconds: 's',
      enabled: 'Ενεργοποιημένο',
      disabled: 'Απενεργοποιημένο'
    },
    actionsAvailable: 'Διαθέσιμες ενέργειες',
    actions: {
      start: 'Εκκίνηση',
      stop: 'Τερματισμός',
      pause: 'Παύση',
      resume: 'Συνέχιση',
      reset: 'Reset',
      migrate: 'Μετεγκατάσταση',
      clone: 'Κλωνοποίηση',
      moveStorage: 'Μετακίνηση σε χώρο αποθήκευσης…',
      moveScope: 'Μετακίνηση σε scope…',
      openConsole: 'Άνοιγμα κονσόλας',
      forceStop: 'Αναγκαστική απενεργοποίηση',
      markTemplate: 'Επισήμανση ως πρότυπο',
      unmarkTemplate: 'Μετατροπή σε VM',
      error: 'Αδυναμία εκτέλεσης της ενέργειας'
    },
    cordon: {
      confirmTitle: 'Ο κόμβος είναι σε συντήρηση',
      confirmHint:
        'Ο κλοιός δεν μπορεί να χαμηλώσει όσο το store του συμπλέγματος είναι εκτός λειτουργίας. Επιβεβαιώνοντας δηλώνετε ότι το γνωρίζετε: η VM ανάβει εκεί ούτως ή άλλως, και η συγκατάθεση καταγράφεται στην εργασία.',
      confirm: 'Άναψε παρόλα αυτά'
    },
    markTemplate: {
      confirmTitle: 'Να επισημανθεί η «{name}» ως πρότυπο;',
      confirmBody: 'Η διαμόρφωση παγώνει και η VM δεν θα μπορεί πλέον να ενεργοποιηθεί — μόνο να κλωνοποιηθεί, ή να ξαναγίνει VM. Όνομα, σημειώσεις και ετικέτες παραμένουν επεξεργάσιμα.',
      confirm: 'Επισήμανση ως πρότυπο',
      moved: 'Η «{name}» είναι τώρα πρότυπο — μετακινήθηκε στην καρτέλα «Πρότυπα».'
    },
    unmarkTemplate: {
      confirmTitle: 'Να μετατραπεί η «{name}» ξανά σε VM;',
      confirmBody: 'Το πρότυπο ξαναγίνεται μια συνηθισμένη VM: επεξεργάσιμη και εκκινήσιμη (η επόμενη εκκίνηση την τοποθετεί σε έναν κόμβο).',
      confirm: 'Μετατροπή σε VM',
      moved: 'Η «{name}» είναι ξανά εικονική μηχανή — μετακινήθηκε στην καρτέλα «Εικονικές μηχανές».'
    },

    // Γύρος #123: αναφορά σε κόμβο μέσω ΕΤΙΚΕΤΑΣ (επιλογέας #106) στους διαλόγους
    // εκκίνησης και μετεγκατάστασης — με προεπισκόπηση του επιλυμένου συνόλου.
    nodeByTag: {
      label: 'Κατά ετικέτα κόμβου',
      hint: 'ετικέτα=τιμή, χωρισμένα με κόμμα (σε AND): ο decider επιλέγει ανάμεσα στους κόμβους που ταιριάζουν',
      invalid: 'Μη έγκυρη μορφή — χρησιμοποιήστε ετικέτα=τιμή, χωρισμένα με κόμμα',
      resolved: 'Μέλη που ταιριάζουν: {nodes}'
    },
    migrate: {
      title: 'Ζωντανή μετεγκατάσταση',
      submit: 'Μετεγκατάσταση',
      target: 'Κόμβος προορισμού',
      auto: 'Αυτόματο (Proximity)',
      hint: 'Η VM μετακινείται χωρίς power cycle. Κάθε χώρος αποθήκευσης που αγγίζει πρέπει να είναι κοινόχρηστος· μια VM σε παύση μετεγκαθίσταται σε παύση.',
      error: 'Η μετεγκατάσταση απορρίφθηκε'
    },
    moveStorage: {
      title: 'Μετακίνηση σε χώρο αποθήκευσης',
      submit: 'Μετακίνηση',
      target: 'Χώρος αποθήκευσης προορισμού',
      noTargets: 'Κανένας χώρος αποθήκευσης δεν δέχεται δίσκους',
      hint: 'Όλοι οι δίσκοι της απενεργοποιημένης VM ταξιδεύουν στον επιλεγμένο χώρο αποθήκευσης, ένας τη φορά, διατηρώντας το id τους — όσοι βρίσκονται ήδη στον προορισμό παραλείπονται. Η πρόοδος ζει στη σελίδα εργασιών.',
      error: 'Η μετακίνηση απορρίφθηκε'
    },
    moveScope: {
      title: 'Μετακίνηση σε scope',
      submit: 'Μετακίνηση',
      target: 'Scope προορισμού',
      hint: 'Η VM αλλάζει scope αμέσως — id και δίσκοι μένουν, οι δίσκοι owned την ακολουθούν, και μπορεί να μείνει ενεργοποιημένη. Σήμερα ζει στο {scope}. Το ποιος τη βλέπει αλλάζει με το scope.',
      error: 'Η μετακίνηση scope απορρίφθηκε'
    },
    start: {
      title: 'Εκκίνηση VM',
      submit: 'Εκκίνηση',
      target: 'Κόμβος προορισμού',
      auto: 'Αυτόματο (συνιστάται)',
      recommended: 'συνιστάται',
      hint: 'Επιλέξτε έναν κόμβο προορισμού ή αφήστε το Proximity να αποφασίσει ανάμεσα στους έγκυρους υποψηφίους. Οι κόμβοι που δεν μπορούν να τη φιλοξενήσουν είναι απενεργοποιημένοι με τον λόγο.',
      error: 'Αδυναμία εκκίνησης της VM'
    },
    console: {
      media: 'Μονάδες CD/DVD',
      mediaGuestToolsHint: 'Περιέχει τα TVirt Guest Tools — από εδώ μπορείτε να τα εξαγάγετε ή να αφαιρέσετε τη μονάδα',
      slotOpsDeferred: 'Σε αυτό το προφίλ η προσθήκη και η αφαίρεση μονάδων εφαρμόζονται στο επόμενο power cycle (οι αλλαγές μέσου είναι άμεσες).',
      mountGuestTools: 'Προσάρτηση TVirt Guest Tools',
      ejectGuestTools: 'Εξαγωγή TVirt Guest Tools',
      bootOrder: 'Σειρά boot',
      bootOrderHint: 'Η νέα σειρά αποθηκεύεται αμέσως και εφαρμόζεται στο επόμενο power cycle — η συνεδρία κονσόλας παραμένει συνδεδεμένη.'
    },
    snapshots: {
      create: 'Δημιουργία στιγμιοτύπου',
      createTitle: 'Δημιουργία στιγμιοτύπου',
      createSubmit: 'Δημιουργία',
      name: 'Όνομα',
      nameHint: 'Γράμματα, ψηφία, τελεία, παύλα, κάτω παύλα.',
      consistencyHint: 'Η συνέπεια είναι αυτόματη: ο guest agent παγώνει τα συστήματα αρχείων όταν αποκρίνεται· διαφορετικά η VM μπαίνει για μια στιγμή σε παύση γύρω από το στιγμιότυπο.',
      memory: 'Συμπερίληψη της μνήμης',
      memoryHint: 'Καταγράφει τη ζωντανή RAM: η επαναφορά συνεχίζει τη VM σε εκτέλεση. Απαιτεί όλους τους δίσκους qcow2.',
      currentChip: 'Είστε εδώ',
      revert: 'Επαναφορά',
      revertTitle: 'Επαναφορά στο «{name}»;',
      revertBody: 'Οι δίσκοι επιστρέφουν στην κατάσταση του στιγμιοτύπου· ό,τι συνέβη μετά χάνεται. Ένα στιγμιότυπο μόνο-δίσκων απαιτεί τη VM απενεργοποιημένη.',
      delete: 'Διαγραφή',
      deleteTitle: 'Διαγραφή του στιγμιοτύπου «{name}»;',
      deleteBody: 'Το σημείο επαναφοράς εξαφανίζεται· το περιεχόμενο των δίσκων μένει ανέπαφο.',
      deleteMergeHint: 'Το δέλτα του συγχωνεύεται στο {children}: κάθε μεταγενέστερο σημείο επαναφοράς παραμένει έγκυρο.',
      deleteDuplication: 'Αποδέχομαι τον διπλασιασμό',
      deleteDuplicationHint: 'Το δέλτα αντιγράφεται σε καθέναν από τους {count} αναγνώστες (τα θυγατρικά snapshot και, αν αυτό είναι το τρέχον, την ενεργή κεφαλή): ο χώρος που καταλαμβάνεται μπορεί να αυξηθεί αντί να μειωθεί.',
      error: 'Η λειτουργία στιγμιοτύπου απορρίφθηκε'
    },
    clone: {
      title: 'Κλωνοποίηση VM',
      submit: 'Κλωνοποίηση',
      name: 'Όνομα του αντιγράφου',
      storage: 'Χώρος αποθήκευσης προορισμού των δίσκων',
      sameStorage: 'Ίδιος με την πηγή',
      full: 'Πλήρες αντίγραφο',
      fullHint: 'Αντιγράφει κάθε byte και κόβει τον δεσμό με τους δίσκους πηγής. Η προεπιλογή είναι συνδεδεμένος κλώνος: στιγμιαίος, αλλά αλυσοδεμένος στην πηγή (μόνο qcow2).',
      hint: 'Ο κλώνος διατηρεί τη διαμόρφωση και το υλικολογισμικό της πηγής· οι διευθύνσεις MAC και η ταυτότητα TPM είναι καινούργιες.',
      markAs: 'Είδος του κλώνου',
      markAsInheritVm: 'Όπως η πηγή (VM)',
      markAsInheritTemplate: 'Όπως η πηγή (πρότυπο)',
      markAsVm: 'Εικονική μηχανή',
      markAsTemplate: 'Πρότυπο',
      markAsHintVm: 'Επιλέξτε «Πρότυπο» για να προαγάγετε το αντίγραφο σε ένα βήμα.',
      markAsHintTemplate: 'Επιλέξτε «Εικονική μηχανή» για ανάπτυξη από αυτό το πρότυπο σε ένα βήμα.',
      error: 'Η κλωνοποίηση απορρίφθηκε'
    },
    bulk: {
      selected: 'επιλεγμένες',
      deleteTitle: {
        one: 'Διαγραφή {count} επιλεγμένης VM;',
        other: 'Διαγραφή {count} επιλεγμένων VM;'
      },
      deleteBody: 'Κάθε VM περνά από τις ίδιες δικλείδες με μια μεμονωμένη διαγραφή· οι απορρίψεις αναφέρονται ανά στοιχείο.',
      done: 'έγιναν δεκτές',
      refused: 'απορρίφθηκαν'
    },
    delete: {
      button: 'Διαγραφή',
      confirmTitle: 'Διαγραφή της «{name}»;',
      confirmBody: 'Η εικονική μηχανή και οι δίσκοι ιδιοκτησίας της θα διαγραφούν. Η ενέργεια δεν είναι αναστρέψιμη.',
      keepDisks: 'Διατήρηση των δίσκων',
      keepDisksHint: 'Οι δίσκοι που δημιουργήθηκαν με τη VM παραμένουν στον χώρο αποθήκευσής τους ως αυτόνομοι δίσκοι.',
      confirm: 'Διαγραφή',
      cancel: 'Άκυρο',
      error: 'Η διαγραφή απέτυχε',
      blockedPhase: 'Τερματίστε πρώτα τη VM',
      blockedProtected: 'Η VM είναι προστατευμένη — αφαιρέστε πρώτα την προστασία',
      blockedDeleting: 'Διαγραφή ήδη σε εξέλιξη'
    },
    logs: {
      title: 'Καταγραφή',
      subtitle: 'Δομημένα πλαίσια καταγραφής των εργασιών που αγγίζουν αυτή τη VM',
      when: 'Πότε',
      task: 'Εργασία',
      level: 'Επίπεδο',
      message: 'Μήνυμα',
      empty: 'Καμία καταγραφή ακόμη',
      loadError: 'Αδυναμία φόρτωσης των καταγραφών — είναι προσβάσιμο το backend TVirt;'
    },
    stop: {
      title: 'Τερματισμός εικονικής μηχανής',
      modeGraceful: 'Ομαλός τερματισμός',
      modeGracefulHint: 'Ζητείται από το λειτουργικό σύστημα guest να τερματιστεί ομαλά (ACPI)· αν αγνοήσει το αίτημα, μετά το timeout ακολουθεί αναγκαστική απενεργοποίηση.',
      modeForced: 'Αναγκαστική απενεργοποίηση',
      modeForcedHint: 'Κόβει το ρεύμα αμέσως, σαν να τραβάτε την πρίζα.',
      timeout: 'Timeout fallback (δευτερόλεπτα)',
      timeoutHint: 'Αναμονή που παραχωρείται στο guest πριν από την αναγκαστική απενεργοποίηση'
    },

    // Το μενού του διαιρούμενου κουμπιού δημιουργίας (Luca 2026-07-23): το «Από
    // το μηδέν» ανοίγει τον οδηγό, οι άλλες δύο επιλογές είναι stub του οδικού χάρτη.
    createFromScratch: 'Από το μηδέν',
    createFromTemplate: 'Από πρότυπο',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Εκτέλεση deploy',
      error: 'Το deploy απέτυχε',
      compatNote: 'Το QuickDeploy απαιτεί template συμβατό με QuickDeploy: η πλατφόρμα προσαρμόζει τον guest (δίκτυο, τομέας, ενεργοποίηση) στην πρώτη εκκίνηση.',
      template: 'Template',
      noTemplates: 'Κανένα template δεν δηλώνει ακόμη συμβατότητα QuickDeploy — δηλώστε την από την καρτέλα Templates (Linux με cloud-init, Windows με cloudbase-init μετά από sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Όνομα host',
      hostnameHint: 'Όνομα host ή FQDN· κενό = το όνομα της VM (Windows: το πολύ 15 χαρακτήρες)',
      ip: 'Διεύθυνση IP',
      ipHint: 'Host και πρόθεμα, π.χ. 192.168.122.101/24· κενό = DHCP',
      gateway: 'Gateway',
      dns: 'Διακομιστές DNS',
      dnsHint: 'Έως τρεις, χωρισμένοι με κόμμα',
      count: 'Στιγμιότυπα',
      countHint: 'Περισσότερα από ένα: ονομάζονται <όνομα>-1…-N, μόνο DHCP',
      user: 'Χρήστης',
      userHint: 'Κενό = ο προεπιλεγμένος χρήστης της εικόνας (Linux) ή Administrator (Windows)',
      password: 'Κωδικός πρόσβασης',
      passwordHint: 'Γράφεται στο παραγόμενο user-data, το οποίο η πλατφόρμα δηλώνει έπειτα μυστικό: κανείς δεν το ξαναδιαβάζει',
      sshKeys: 'Δημόσια κλειδιά SSH',
      sshKeysHint: 'Ένα ανά γραμμή (ssh-ed25519 AAAA… σχόλιο)',
      productKey: 'Product key Windows',
      kmsServer: 'Διακομιστής KMS',
      kmsHint: 'Host ή host:θύρα — απαιτεί product key (κλειδί πελάτη KMS)',
      adDomain: 'Ένταξη σε τομέα Active Directory',
      adDomainHint: 'Κενό = χωρίς ένταξη σε τομέα',
      adUser: 'Λογαριασμός ένταξης',
      adPassword: 'Κωδικός του λογαριασμού ένταξης',
      adOu: 'OU προορισμού (προαιρετικό)',
      advanced: 'Για προχωρημένους: ακατέργαστα έγγραφα',
      userData: 'user-data (ακατέργαστο)',
      userDataHint: 'Παρακάμπτει το παραγόμενο user-data: χρήστης, κωδικός, κλειδιά και τα πεδία Windows παραπάνω πρέπει να μείνουν κενά',
      networkConfig: 'network-config (ακατέργαστο)',
      networkConfigHint: 'Παρακάμπτει το παραγόμενο δίκτυο: IP, gateway και DNS παραπάνω πρέπει να μείνουν κενά',
      secret: 'Μεταχείριση του ακατέργαστου user-data ως μυστικού',
      secretHint: 'Σημειωμένο ως μυστικό, παύει να επιστρέφεται από το API σε οποιονδήποτε και ταξιδεύει στο Checkpoint σφραγισμένο με το masterpass',
      startNow: 'Εκκίνηση αμέσως',
      startNowHint: 'Κάθε στιγμιότυπο ξεκινά μόλις οριστεί· το seed δημιουργείται σε εκείνη την εκκίνηση'
    },

    create: {
      nicAttachmentNetwork: 'Λογικό δίκτυο (fabric)',
      nicNetwork: 'Λογικό δίκτυο',
      nicNetworkHint: 'Ο ΣΥΝΙΣΤΩΜΕΝΟΣ δρόμος (F3): η vNIC πραγματώνεται στο ΠΑΡΑΓΩΓΟ bridge του εξυπηρετούντος κόμβου — το bridge γεννιέται στο ρητό apply του fabric, και μια εκκίνηση σε κόμβο που δεν το φέρει ακόμα απορρίπτει μιλώντας. Όταν φύγει η τελευταία αναφορά του στόλου, το bridge πέφτει στο επόμενο apply.',
      button: 'Δημιουργία VM',
      title: 'Δημιουργία εικονικής μηχανής',
      dialogTitle: 'Δημιουργία εικονικής μηχανής',
      stepGeneral: 'Γενικά',
      stepGeneralHint: 'Όνομα και προφίλ',
      stepCompute: 'CPU και RAM',
      stepComputeHint: 'Τοπολογία και μεγέθη',
      stepDisks: 'Δίσκοι',
      stepDisksHint: 'Δημιουργία ή σύνδεση',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Μονάδες και μέσα',
      stepNetwork: 'Δίκτυο',
      stepNetworkHint: 'NIC: trunk ή γέφυρα',
      stepSummary: 'Σύνοψη',
      stepSummaryHint: 'Έλεγχος και δημιουργία',
      name: 'Όνομα',
      nameHint: 'Πεζά γράμματα, ψηφία και παύλες (DNS-1123)',
      nextButton: 'Επόμενο',
      prevButton: 'Προηγούμενο',
      submitButton: 'Δημιουργία',
      creating: 'Δημιουργία…',
      sockets: 'Socket',
      cores: 'Πυρήνες ανά socket',
      threads: 'Νήματα ανά πυρήνα',
      totalVcpus: 'Συνολικές vCPU',
      memoryGib: 'Μνήμη (GiB)',
      cpuModelHint: 'Το «host» εκθέτει τη CPU του host',
      cpuLimitHint: 'Ανώτατο όριο σε πυρήνες host — κενό = απεριόριστο',
      cpuNestedHint: "Εκθέτει vmx/svm στον guest ώστε να τρέχει δικό του hypervisor — απαιτεί μοντέλο CPU host και κόμβο με ενεργό nested",
      newDisk: 'Νέος δίσκος',
      attachDisk: 'Σύνδεση υπάρχοντος δίσκου',
      diskStorage: 'Χώρος αποθήκευσης',
      diskSize: 'Μέγεθος (GiB)',
      diskSelect: 'Δίσκος',
      addDisk: 'Προσθήκη δίσκου',
      addCdrom: 'Προσθήκη μονάδας CD/DVD',
      addNic: 'Προσθήκη διεπαφής δικτύου',
      remove: 'Αφαίρεση',
      slotLimit: 'Συμπληρώθηκε το όριο των slot',
      cdromImage: 'Εικόνα (κενή μονάδα αν λείπει)',
      nicAttachment: 'Σύνδεση',
      nicAttachmentTrunk: 'Trunk επικάλυψης',
      nicAttachmentBridge: 'Γέφυρα host',
      nicUntagged: 'Δίκτυο επικάλυψης untagged',
      nicUntaggedNone: 'Κανένα (μόνο tagged)',
      nicTrunkHint: 'Τουλάχιστον μία πλευρά: ένα δίκτυο επικάλυψης untagged και/ή αντιστοιχίσεις VLAN tagged — η VM μπορεί να τρέχει μόνο στους host που δηλώνει κάθε αναφερόμενο δίκτυο επικάλυψης',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Δίκτυο επικάλυψης',
      addTagged: 'Προσθήκη VLAN tagged',
      nicBridge: 'Όνομα γέφυρας host',
      nicBridgeHint: 'Γέφυρα NM κατά όνομα — η VM μπορεί να τρέχει μόνο στους διακομιστές των οποίων το δίκτυο host δηλώνει αυτή τη γέφυρα',
      nicMac: 'MAC (αυτόματα αν κενό)',
      noDisksHint: 'Κανένας δίσκος: η VM θα έχει μόνο τις μονάδες CD/DVD που προσθέτετε.',
      noCdromsHint: 'Καμία μονάδα CD/DVD: προσθέστε μία για εκκίνηση από εικόνα ISO.',
      mountGuestTools: 'Προσάρτηση TVirt Guest Tools στην πρώτη εκκίνηση',
      mountGuestToolsHint: 'Βάζει το ISO με τα προγράμματα οδήγησης virtio και τον guest agent σε μια κενή μονάδα CD (προστίθεται αν χρειάζεται) — το πρόγραμμα εγκατάστασης των Windows τα χρειάζεται για να δει τους δίσκους του.',
      noNicsHint: 'Καμία διεπαφή δικτύου: η VM θα εκκινήσει χωρίς συνδεσιμότητα.',
      taggedMappings: 'Αντιστοιχίσεις VLAN tagged',
      summaryDevices: 'Συσκευές',
      bootOrderTitle: 'Σειρά boot',
      bootOrderHint: 'Σύρετε για αναδιάταξη — κερδίζει η πρώτη εκκινήσιμη συσκευή· οι NIC εκκινούν PXE',
      bootOrderUp: 'Μετακίνηση πάνω',
      bootOrderDown: 'Μετακίνηση κάτω',
      createError: 'Η δημιουργία απέτυχε'
    },
    edit: {
      button: 'Επεξεργασία',
      title: 'Επεξεργασία εικονικής μηχανής',
      cancel: 'Άκυρο',
      save: 'Αποθήκευση',
      error: 'Η επεξεργασία απέτυχε',
      modelStoppedOnly: 'Τροποποιήσιμο μόνο με τη VM απενεργοποιημένη',
      firmwareStoppedOnly: 'Το υλικολογισμικό τροποποιείται μόνο με τη VM απενεργοποιημένη — στην επόμενη εκκίνηση η μηχανή ξεκινά με το νέο υλικολογισμικό και οι μεταβλητές UEFI διατηρούνται',
      hugePagesStoppedOnly: 'Τροποποιήσιμο μόνο με τη VM απενεργοποιημένη — στην επόμενη εκκίνηση η μνήμη γεννιέται με το νέο υπόστρωμα',
      runningHint: 'Οι αλλαγές εφαρμόζονται στο επόμενο power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Μνήμη',
      sectionPolicy: 'Πολιτικές'
    },
    devices: {
      networkChip: 'δίκτυο fabric',
      title: 'Συσκευές',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Προσθήκη συσκευής USB',
      addUsbTitle: 'Απαίτηση κλάσης συσκευών USB',
      usbClassHint:
        'Η VM ζητά μια ΚΛΑΣΗ συσκευών USB (μια τιμή μιας ετικέτας usb-device), ποτέ μια συγκεκριμένη συσκευή: κατά την εκκίνηση επιλέγεται και δεσμεύεται η συγκεκριμένη ελεύθερη συσκευή στον κόμβο. Βάλτε ετικέτες στις καταχωρισμένες συσκευές στο «Συστοιχία › Πόροι USB και PCIe».',
      usbTag: 'Ετικέτα (usb-device)',
      usbValue: 'Τιμή της κλάσης',
      noUsbTags: 'Καμία ετικέτα usb-device — δημιουργήστε μία και βάλτε ετικέτες στις καταχωρισμένες συσκευές στο «Συστοιχία › Πόροι USB και PCIe».',
      noUsbValues: 'Αυτή η ετικέτα δεν έχει ακόμη δηλωμένες τιμές.',
      usbEmpty: 'Καμία απαίτηση USB — προσθέστε μια κλάση για να περάσετε μια συσκευή κατά την εκκίνηση.',
      usbClassChip: 'κλάση',
      usbPortChip: 'θύρα',
      usbUnclaimed: 'Καμία δεσμευμένη συσκευή — επιλύεται κατά την εκκίνηση της VM.',
      addGpu: 'Προσθήκη GPU',
      addGpuTitle: 'Απαίτηση κλάσης GPU',
      gpuClassHint:
        'Η VM ζητά μια ΚΛΑΣΗ GPU (μια τιμή μιας ετικέτας gpu-device), ποτέ μια συγκεκριμένη κάρτα: κατά την εκκίνηση η συγκεκριμένη ελεύθερη κάρτα επιλέγεται και δεσμεύεται στον κόμβο, και περνά ΜΑΖΙ όλη η ομάδα IOMMU της. Βάλτε ετικέτες στις καταχωρισμένες GPU στο «Συστοιχία › Πόροι USB και PCIe».',
      gpuTag: 'Ετικέτα (gpu-device)',
      gpuValue: 'Τιμή της κλάσης',
      noGpuTags: 'Καμία ετικέτα gpu-device — δημιουργήστε μία και βάλτε ετικέτες στις καταχωρισμένες GPU στο «Συστοιχία › Πόροι USB και PCIe».',
      noGpuValues: 'Αυτή η ετικέτα δεν έχει ακόμη δηλωμένες τιμές.',
      gpuEmpty: 'Καμία απαίτηση GPU — προσθέστε μια κλάση για να περάσετε μια κάρτα κατά την εκκίνηση.',
      gpuClassChip: 'κλάση',
      gpuGroupChip: 'ομάδα IOMMU ×',
      gpuUnclaimed: 'Καμία δεσμευμένη κάρτα — επιλύεται κατά την εκκίνηση της VM.',
      gpuPowerCycle: 'Κανένα hotplug GPU — οι αλλαγές ισχύουν από το επόμενο power cycle (PendingRestart)',
      actions: 'Ενέργειες',
      attachDisk: 'Προσθήκη δίσκου',
      attachDiskTitle: 'Προσθήκη ενός δίσκου',
      attach: 'Σύνδεση',
      noFreeDisks: 'Κανένας αχρησιμοποίητος δίσκος — δημιουργήστε έναν στο «Εικονικές μηχανές › Αχρησιμοποίητοι δίσκοι».',
      addCdrom: 'Προσθήκη μονάδας',
      addCdromTitle: 'Προσθήκη μονάδας CD/DVD',
      editCdromTitle: 'Αλλαγή εικόνας CD/DVD',
      changeMedia: 'Αλλαγή εικόνας CD/DVD',
      ejectMedium: 'Εξαγωγή',
      mountGuestTools: 'Προσάρτηση TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools προσαρτημένα',
      guestToolsClickMount: 'Βάζει το ISO TVirt Guest Tools στην πρώτη κενή μονάδα CD/DVD',
      guestToolsClickUnmount: 'Κάντε κλικ για εξαγωγή — η μονάδα παραμένει, κενή',
      guestToolsNoSlot: 'Καμία κενή μονάδα CD/DVD — προσθέστε μια μονάδα (ή εξαγάγετε ένα μέσο) για να προσαρτήσετε τα TVirt Guest Tools',
      guestToolsSkew: 'Προσαρτημένο v{pinned}· ο κόμβος {node} εξυπηρετεί τώρα v{current}: εξάγετε και προσαρτήστε ξανά για ενημέρωση',
      ejectGuestTools: 'Εξαγωγή TVirt Guest Tools (η μονάδα παραμένει, κενή)',
      guestToolsEjectConfirmTitle: 'Εξαγωγή των TVirt Guest Tools;',
      guestToolsEjectConfirmBody: 'Το μέσο εξάγεται από την ενεργοποιημένη VM — η μονάδα CD/DVD παραμένει, κενή.',
      applyLive: 'Άμεση εφαρμογή (η VM είναι ενεργοποιημένη)',
      addNic: 'Προσθήκη διεπαφής',
      addNicTitle: 'Προσθήκη διεπαφής δικτύου',
      editNicTitle: 'Επεξεργασία διεπαφής δικτύου',
      bridgeChip: 'γέφυρα',
      cable: 'Εικονικό καλώδιο',
      plug: 'Σύνδεση του εικονικού καλωδίου',
      unplug: 'Αποσύνδεση του εικονικού καλωδίου',
      remove: 'Αφαίρεση',
      removeTitle: 'Αφαίρεση του «{device}»;',
      removeBody: 'Με τη VM ενεργοποιημένη η αλλαγή εφαρμόζεται στο επόμενο power cycle. Δίσκοι και εικόνες αποσυνδέονται, ποτέ δεν διαγράφονται.'
    }
  }
}
